import React from 'react';
import styled from 'styled-components';
import Summary from 'routes/checkoutPage/components/travelSummary/components/summarySection/SummarySection';
import { FormattedMessage } from 'i18n';
import servicesIconsMap from 'routes/checkoutPage/constants/servicesIconsMap';
import {
  TRANSFERS as TRANSFERS_SERVICE,
  CAR_RENTAL as CAR_RENTAL_SERVICE,
  INSURANCES as INSURANCES_SERVICE,
  CANCELLATION_PROTECTION as CANCELLATION_PROTECTION_SERVICE,
  CO2_COMPENSATION as CO2_COMPENSATION_SERVICE,
  EARTH_TODAY as EARTH_TODAY_SERVICE,
} from 'routes/checkoutPage/constants/servicesKeys';
import { getCO2CompensationPrice } from 'state/checkoutPage/co2Compensation/selectors';
import SelectedOtherExtrasComponent from './components/selectedOtherExtras/SelectedOtherExtrasComponent';

function OtherExtrasSummaryComponent({
  summaryKey,
  transfers,
  vehicleRentals,
  insurances,
  co2compensation,
  earthToday,
  cancellationProtections,
  currency,
}) {
  const title = (
    <FormattedMessage id={'otherExtras.label'} description={'Other Extras'} defaultMessage={'Other Extras'} />
  );
  return (
    <Summary summaryKey={summaryKey} title={title}>
      <Root>
        {transfers && (
          <SelectedOtherExtrasComponent
            icon={servicesIconsMap[TRANSFERS_SERVICE]}
            description={transfers.name}
            price={transfers.prices.total.amount}
          />
        )}
        {vehicleRentals &&
          vehicleRentals.map((vehicleRental) => (
            <SelectedOtherExtrasComponent
              key={vehicleRental.productToken}
              icon={servicesIconsMap[CAR_RENTAL_SERVICE]}
              description={vehicleRental.model.name}
              price={vehicleRental.prices.payment.amount}
            />
          ))}
        {insurances && (
          <SelectedOtherExtrasComponent
            icon={servicesIconsMap[INSURANCES_SERVICE]}
            description={insurances.name}
            price={insurances.total}
            tax={insurances.taxAmount}
          />
        )}
        {co2compensation && (
          <SelectedOtherExtrasComponent
            icon={servicesIconsMap[CO2_COMPENSATION_SERVICE]}
            description={
              <FormattedMessage
                id={`${CO2_COMPENSATION_SERVICE}.label`}
                description={CO2_COMPENSATION_SERVICE}
                defaultMessage={CO2_COMPENSATION_SERVICE}
              />
            }
            price={getCO2CompensationPrice(co2compensation)}
          />
        )}
        {earthToday && (
          <SelectedOtherExtrasComponent
            icon={servicesIconsMap[EARTH_TODAY_SERVICE]}
            description={
              <FormattedMessage
                id={`${EARTH_TODAY_SERVICE}.title`}
                description={'EarthToday'}
                defaultMessage={'EarthToday'}
              />
            }
            price={earthToday.price}
          />
        )}
        {cancellationProtections && (
          <SelectedOtherExtrasComponent
            icon={servicesIconsMap[CANCELLATION_PROTECTION_SERVICE]}
            description={cancellationProtections.description}
            price={cancellationProtections.total}
          />
        )}
      </Root>
    </Summary>
  );
}

export default OtherExtrasSummaryComponent;

const Root = styled.div`
  > * {
    margin-bottom: 20px;
  }
`;
